import { useAppSelector } from "../../../redux/hooks";
import { useSearchParams } from "react-router-dom";
import { SEARCH_MODE_PREDICTIVE } from "../../../utils/const";
import { normalizeString } from "../../../utils/utils";

export const useHighlightText = () => {
    const [params] = useSearchParams();
    const searchMode = params.get('searchMode');
    const { searchMetadata } = useAppSelector((state) => state.indicator);

    const highlight = (text: string) => {
        if (!searchMetadata || searchMode === SEARCH_MODE_PREDICTIVE) {
            return <>{text}</>;
        }

        const pattern = searchMetadata?.terms
            .map(term => normalizeString(term).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
            .join('|');

        const normalizedText = normalizeString(text);
        const regex = new RegExp(`(${pattern})`, 'gi');
        const parts = normalizedText.split(regex);

        let offset = 0;
        return (
            <>
                {parts.map((part, i) => {
                    const original = text.slice(offset, offset + part.length);
                    offset += part.length;
                    return i % 2 === 1
                        ? <mark key={i} style={{ color: 'inherit', backgroundColor: 'rgb(255 255 0 / 50%)' }}>
                            {original}
                        </mark>
                        : original;
                })}
            </>
        );
    };

    return { highlight };
};